import React from 'react';
import { Box } from '@mui/material';
import Logo from '../resources/images/logos/LogoColor.png';
import WelcomeBackGround from '../resources/images/stock/welcomloop.png';
import Footer from '../components/ui/footer/index';

const WelcomeLayout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden'
      }}>
      <Box
        component="img"
        src={WelcomeBackGround}
        alt="Background"
        sx={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          height: 'auto',
          maxHeight: '100vh',
          width: 'auto',
          objectFit: 'contain',
          zIndex: 0,
          pointerEvents: 'none'
        }}
      />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: { xs: 'center', md: 'flex-start' },
          px: { xs: 2, md: 8 },
          pt: { xs: 6, md: 6 },
          pb: 6,
          zIndex: 1,
          width: '100%'
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' },
            mb: 2
          }}>
          <Box component="img" src={Logo} alt="Fairtree logo" width="400px" />
        </Box>

        <Box
          sx={{
            width: { xs: '100%', sm: '80%', md: '400px' },
            backgroundColor: 'white',
            p: { xs: 3, md: 0 },
            boxShadow: {
              xs: '0px 4px 10px rgba(0, 0, 0, 0.05)',
              md: 'none'
            },
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' }
          }}>
          {children}
        </Box>
      </Box>

      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default WelcomeLayout;
